import v from "@/lib/validator";
import { TFunction } from "i18next";

const RegisterLicencaSchema = (translate: TFunction) => {
  const requiredValidation = v.methods().required({
    message: translate("LicenceForm.inputs.errorsMessages.required"),
  });

  return v.object({
    clienteId: requiredValidation,
    produtoId: requiredValidation,
    tipoLicenca: requiredValidation,
    dataDeExpiracao: v.methods()
      .required({ message: translate("LicenceForm.inputs.errorsMessages.required") })
      .futureDate({ message: translate("LicenceForm.inputs.errorsMessages.expiredDate") }),

    emailNotificacaoInterna: v.methods()
      .email({ message: translate("LicenceForm.inputs.errorsMessages.email") }),

  });
};

export default RegisterLicencaSchema;
